import { Component,Input,OnInit } from '@angular/core';
import { Od } from "../../../../../domain/od/od";
import { SettingsODState } from "../../../../../domain/settings/settings";
import { ODService } from "../../../od.service";
import { Store } from "@ngrx/store";
import { AppState } from "../../../../../domain/appstate";
import * as settingsActions from "../../../../../reducers/settings";
import { TypePortee } from "../../../../../domain/workflow/workflow";
import { EngagementsFactures } from "../../../../../domain/od/engagements/factures/engagements-factures";
import { TypeEngagementFacture } from "../../../../../domain/od/engagements/factures/engagements-factures-item";
import { finalize,first } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";

/**
 * Composant du cadre "Récapitulatif des écarts de facturation"
 *
 * @author Laurent Convert
 * @date 26/10/2021
 */
@Component({
	selector: 'od-engagements-factures',
	templateUrl: './od-engagements-factures.component.html'
})
export class OdEngagementsFacturesComponent implements OnInit {
	/* Déclaration pour accès dans le template */
	TypeEngagementFacture = TypeEngagementFacture;

	/** Ordre de mission */
	@Input() od: Od = null;

	/** Paramétrage de l'OD */
	settings: SettingsODState;

	/** factures */
	engagements: EngagementsFactures;

	/** Indicateur du chargement en cours */
	isLoading: boolean = false;

	/** Indique si le détail de la ligne est affiché */
	isOuvert: boolean = true;

	/**
	 * Constructeur
	 */
	constructor(private odService: ODService,
				private store: Store<AppState>,
				public translateService: TranslateService,
				private toastrService: ToastrService) {
	}

	/**
	 * Initialisation du composant
	 */
	ngOnInit() {
		//Chargement des données
		this.isLoading = true;

		//Chargement du paramétrage de l'OD
		this.store.dispatch({
			type: settingsActions.LOAD_SETTINGS,
			payload: TypePortee.OD
		});

		//Sélection du paramétrage
		this.store.select(state => state.settings?.[TypePortee.OD]).subscribe(settings => this.settings = settings);

		//Chargement des données
		this.refresh();
	}

	/**
	 * Rafraichissement des données
	 */
	refresh(): void {
		//Chargement des données
		this.isLoading = true;

		//Récupération des données sur les factures
		this.odService.getEngagementsFacture(this.od?.idOd)
			.pipe(first(), finalize(() => { this.isLoading = false; }))
			.subscribe({
				next: (engagementsFacture) => {
					//Instanciation de l'objet contenant les données sur les factures
					this.engagements = new EngagementsFactures(engagementsFacture);
				},
				error: () => {
					//Message d'erreur
					this.toastrService.error(this.translateService.instant('global.errors.chargement'));
				}
			});
	}

}